

<template>
  <div class="col-lg-12" style="padding: 20px">
    <div class="main-card mb-3 card" style="margin-left: 10px">
      <div class="card-body">
        <h5 class="card-title">
          ID주문내역
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            주문관리 → ID주문내역
          </div>
        </h5>

        <query-grid :config="config" ref="qg">
           <template #resultactions="props"
            ><!--추후 제공예정-->
            <p style="padding-left: 10px; font-size: 16px; line-height: 28px">
              - 아이디 주문 내역을 확인하는 메뉴입니다.<br />
              -
              <span style="font-weight: bold; color: #1e73d5"
                >아이디주문은 [회원관리(ID주문) → 회원목록(ID주문)] 메뉴</span
              >에서 학생 이름 클릭 후 가능합니다. <br />
              -
              <span style="font-weight: bold; color: #1e73d5"
                >[결제만료] 상태의 주문건은 주문 취소</span
              >하셔야 아이디 재주문이 가능합니다. <br />
              -
              <span style="font-weight: bold; color: #1e73d5">주문건 취소</span
              >는 비고란의 [상세] 클릭 후 취소 가능합니다.
            </p>
            <div
              style="
                float: right;
                margin: 2px;
                z-index: 9999;
                position: relative;
              "
            >
          <template v-if="this.$root.guiPerm == 'ROOT'">
            <Enddate-multiple :students="props.checked" #default="m"><button class="btn btn-success btn-sm" :data-bs-toggle="m.dataBsToggle" :data-bs-target="m.dataBsTarget" >일괄변경</button></Enddate-multiple>
          </template>
              <IMSMultiple
                :placeholders="[
                  { name: '학생명', locked: true },
                  { name: '아이디', locked: true },
                  { name: '학원명', locked: true, hidden: true },
                  { name: '결제링크', locked: true, hidden: true },
                ]"
                :receivers="receivers()"
                :buttonClick="fetchReceivers"
                baseTitle="[차일드유] 컨텐츠비 결제 안내"
                :baseText="'[학원명] [학생명] 학생 컨텐츠요금 결제 [결제링크]'"
                service="pay"
                :disableModifyText="true"
                buttonText='<i class="fa-solid fa-comment-sms"></i> 결제링크 전송'
              />
            </div>
          </template>

          <template #items="props" style="z-index: 9999; position: relative">
            <tr
              v-for="subscription in props.records"
              v-bind:key="subscription.id"
            >
              <td scope="col">
                <input type="checkbox" v-model="subscription.checked" />
              </td>
              <td scope="col">{{ subscription.id }}</td>
              <td scope="col" style="font-size: 12px">
                <Subscription
                  :subscription="subscription"
                  :ref="'sub' + subscription.id"
                ></Subscription>
                &nbsp;<span
                  class="btn btn-warning btn-sm"
                  style="padding: 1px 2px; font-size: 10px"
                  v-if="subscription.previous_order"
                  >연장</span
                >
              </td>
              <td scope="col">{{ subscription.createdAt }}</td>
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="subscription.p_biz" :biz="subscription.p_biz" />
              </td>
              <td
                style="
                  text-align: center;
                  white-space: nowrap;
                  width: 100px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                <Business v-if="subscription.biz" :biz="subscription.biz" />
              </td>
              <td scope="col">{{ subscription.username }}</td>
              <td scope="col">
                <Student
                  :student="{
                    id: subscription.studentId,
                    name: subscription.hanName,
                  }"
                />
              </td>
              <td scope="col" style="font-size: 12px">
                {{ subscription.productName }}
              </td>
              <td scope="col">{{ subscription.period }}</td>
              <td scope="col">{{ subscription.level }}</td>
              <td scope="col">
                <template v-if="subscription.paymentMethod == 'CARD_ONPG'"
                  ><span
                    style="
                      font-size: 10px;
                      background: #00acea;
                      padding: 2px 4px;
                      color: #fff;
                      border-radius: 4px;
                      border: 1px solid #0095ea;
                    "
                    ><i class="fa-regular fa-credit-card"></i>&nbsp;카드</span
                  ></template
                >
                <template v-if="subscription.paymentMethod == 'CARD_OFFPG'"
                  ><span
                    style="
                      font-size: 10px;
                      background: #009aea;
                      padding: 2px 4px;
                      color: #fff;
                      border-radius: 4px;
                      border: 1px solid #0095ea;
                    "
                    ><i class="fa-brands fa-cc-visa"></i>&nbsp;카드(오프)</span
                  ></template
                >
                <template v-if="subscription.paymentMethod == 'CASH'"
                  ><span
                    style="
                      font-size: 10px;
                      background: #eb4e4e;
                      padding: 2px 4px;
                      color: #fff;
                      border-radius: 4px;
                      border: 1px solid #e92222;
                    "
                    ><i class="fa-solid fa-coins"></i>&nbsp;현금</span
                  ></template
                >
              </td>
              <td scope="col" style="font-size: 12px">
                {{ parseInt(subscription.price).toLocaleString() }}원
              </td>
              <td scope="col">{{ subscription.endDate }}</td>
              <td scope="col">
                <span v-if="subscription.status == 'WAITING_PAYMENT'"
                  ><span class="btn-success btn-sm">결제대기</span><br /><span
                    style="font-size: 12px; color: #d61518"
                    v-if="!subscription.previous_order"
                    >{{ subscription.startDate.substr(2, 8) }}</span
                  ></span
                >
                <span v-if="subscription.status == 'PAYMENT_LATE'"
                  ><span class="btn-secondary btn-sm">결제만료</span></span
                >
                <span v-if="subscription.status == 'ACTIVE'"
                  ><span class="btn-primary btn-sm">사용중</span></span
                >
                <span v-if="subscription.status == 'PENDING'"
                  ><span class="btn-warning btn-sm">대행대기</span><br /><span
                    style="font-size: 12px; color: #d61518"
                    v-if="!subscription.previous_order"
                    >{{ subscription.startDate.substr(2, 8) }}</span
                  ></span
                >
                <span v-if="subscription.status == 'ENDED'"
                  ><span class="btn-dark btn-sm">만료됨</span></span
                >
                <span v-if="subscription.status == 'CANCELLED'"
                  ><span class="btn-danger btn-sm">취소됨</span><br /><span
                    style="font-size: 12px; color: #d61518"
                    v-if="subscription.cancel_request_date"
                    >{{ subscription.cancel_request_date.substr(2, 8) }}</span
                  ></span
                >
                <span v-if="subscription.status == 'RESERVED'"
                  ><span class="btn-warning btn-sm">연장</span></span
                >
                <span v-if="subscription.status == 'CONFIRMING_PAYMENT'"
                  ><span class="btn-warning btn-sm">결제확인중</span><br /><span
                    style="font-size: 12px; color: #d61518"
                    v-if="!subscription.previous_order"
                    >{{ subscription.startDate.substr(2, 8) }}</span
                  ></span
                >
                <span v-if="subscription.status == 'CANCEL_PENDING'"
                  ><span class="btn-warning btn-sm">취소 대기중</span
                  ><br /><span
                    style="font-size: 12px; color: #d61518"
                    v-if="subscription.cancel_request_date"
                    >{{ subscription.cancel_request_date.substr(2, 8) }}</span
                  ></span
                >
              </td>
              <td scope="col" style="text-align: left">
                <button
                  class="btn-gradient cyan mini" style="font-size:12px; padding:2px 8px;"

                  v-on:click="
                    $refs['sub' + subscription.id.toString()][0].openModal()
                  "
                >
                  상세</button
                ><br />
                <button
                  class="btn-gradient red mini" style="font-size:12px; padding:2px 8px;"

                  v-if="
                    subscription.status == 'WAITING_PAYMENT' &&
                    subscription.paymentMethod == 'CARD_ONPG'
                  "
                  v-on:click="
                    $refs['sub' + subscription.id.toString()][0].openPayModal()
                  "
                >
                  결제
                </button>

                <!--button class="btn btn-warning btn-sm" style="padding:2px 4px; font-size:12px;" v-if="subscription.status == 'ACTIVE'"
                  @click="cancel(subscription.id)">환불</button-->
              </td>
              <td scope="col" v-if="this.$route.query.show_fee">
                {{ parseInt(subscription.retail_margin).toLocaleString() }}원
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>
</template>

<style>
.hidtype {
  border: 0;
  text-align: center;
  background: #f8f8f8;
  border: 1px solid #f0f0f0;
  padding: 10px 0;
}

.hidtype-error {
  color: red;
}

.hidtype-changed {
  color: goldenrod;
}
</style>

<script>
// @ is an alias to /src

import IMS from "../components/IMS";
import IMSMultiple from "../components/IMSMultiple";
import Business from "../components/Business";
import Student from "../components/detail_pages/Student";
import Subscription from "../components/detail_pages/Subscription";
import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import QueryGrid from "../components/QueryGrid";
import createSubscription from "../components/CreateSubscription.vue";
import StudentBatchReg from "../components/StudentBatchReg.vue";
import EnddateMultiple from "../components/EnddateMultiple";
import axios from "axios";

export default {
  name: "Home",
  components: {
    IMS,
    Business,
    Tree,
    treeBtn,
    Student,
    IMSMultiple,
    QueryGrid,
    Subscription,
    createSubscription,
    EnddateMultiple,
    StudentBatchReg,
  },
  mounted() {
    if (this.$root.guiPerm == "ROOT") {
      this.config.search_fields.push({
        id: "search_del",
        name: "삭제여부",
        type: "switch",
        filter_type: {
          false: "정상",
          true: "삭제",
        },
      });
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      /* this.$refs.qg.pushSetting("status_filter_ACTIVE", true); */
      this.config.columns.splice(4, 1);
    }

    if (this.$route.query.show_fee) {
      this.config.columns.push({
        id: "retail_margin",
        sortable: true,
        name: "수수료",
        excel_print: (v) => {
          return v.retail_margin;
        },
      });
    }
  },
  methods: {
    getSubscriptions() {
      axios
        .get("/subscriptions?student=" + this.selStudent.id)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.selStudent.subscriptions = response.data.result;
          }
        });
    },
    createSubscription() {
      axios
        .post("/subscriptions", {
          student: this.selStudent.id,
          product: this.selProduct.id,
          paymentMethod: this.payMethod,
          hopeStart: this.is_extend
            ? this.addData.subscription.endDate
            : this.addData.hopeStart,
          level: this.is_extend
            ? this.addData.subscription.level
            : this.addData.level,
          previous_order: this.is_extend ? this.addData.subscription.id : "",
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "ID 추가 실패: " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.search();
            $.notify(
              {
                // options
                message: "신청되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
          }
        });
    },
    fetchSubscriptionsOfStudent(student) {
      var extras = "";
      console.log(student);
      axios.get("/subscriptions?student=" + student.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.ext_subscriptions = response.data.result;
        }
      });
    },
    chgExtend() {
      if (!this.is_extend) {
        this.fetchProducts();
      }
    },
    extendForm() {
      this.is_extend = true;
      this.selStudent = { id: this.selSub.studentId };
      this.addData.subscription = this.selSub;
      this.fetchProducts(this.selSub);
      this.fetchSubscriptionsOfStudent(this.selStudent);
      this.hide_order_studentName = true;
      this.hide_order_previousSub = true;
    },
    resetForm() {
      this.is_extend = false;
      this.selStudent = {};
      this.hide_order_studentName = false;
      this.hide_order_previousSub = false;
    },
    fetchReceivers() {
      if (!this.$refs.qg) {
        $.notify(
          {
            // options
            message: "그리드가 아직 로드되지 않아 정보를 사용할 수 없습니다.",
          },
          {
            // settings
            type: "warning",
            z_index: 9999,
          }
        );
        return;
      }
      this.batchSubscriptionsDetail = [];
      this.batchSubscriptionsURL = [];

      $.notify(
        {
          // options
          message: "데이터 로드 중입니다. 잠시만 기다려주세요 ..",
        },
        {
          // settings
          type: "warning",
          z_index: 9999,
        }
      );
      var promises = [];
      this.$refs.qg.checked.forEach((subscription, i) => {
        promises.push(
          new Promise((resolve) => {
            axios.get("/subscriptions/" + subscription.id).then((response) => {
              resolve();
              if (response.data.error) {
                $.notify(
                  {
                    // options
                    message:
                      "데이터를 조회할 수 없습니다. " + response.data.error,
                  },
                  {
                    // settings
                    type: "danger",
                    z_index: 9999,
                  }
                );
              } else {
                this.batchSubscriptionsDetail[i] = response.data.result;
              }
            });
          })
        );
        promises.push(
          new Promise((resolve) => {
            axios
              .get("/subscriptions/" + subscription.id + "/payments/url")
              .then((response) => {
                resolve();
                if (response.data.error) {
                  $.notify(
                    {
                      // options
                      message:
                        "데이터를 조회할 수 없습니다. " + response.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  this.batchSubscriptionsURL[i] = {
                    url: this.$root.baseUrl + response.data.url,
                    expiry: response.data.expiry,
                  };
                }
              });
          })
        );
      });

      Promise.all(promises).then(() => {
        $.notify(
          {
            // options
            message: "로드가 완료되었습니다.",
          },
          {
            // settings
            type: "success",
            z_index: 9999,
          }
        );
      });
    },
    receivers: function () {
      var list = [];
      if (this.$refs.qg) {
        //console.log(v.paymentMethod);
        //console.log(this.$refs.qg.checked);
        this.$refs.qg.checked.forEach((v, i) => {
          //console.log(v.status);
          if(v.paymentMethod != 'CASH' && v.status != 'RESERVED' && v.status != 'ACTIVE' && v.status != 'CANCELLED' ){
            var receiver = { args: [] };
            receiver.args[0] = v.hanName;
            receiver.args[1] = v.username;
            receiver.args[2] = v.p_biz.name;

            if (this.batchSubscriptionsDetail[i]) {
              receiver.phone = this.batchSubscriptionsDetail[i].phone;
              receiver.targetStudent = this.batchSubscriptionsDetail[i].studentId;
              receiver.p_bizId = this.batchSubscriptionsDetail[i].p_biz.id;
            }
            if (this.batchSubscriptionsURL[i]) {
              //receiver.args[4] = this.batchSubscriptionsURL[i].expiry;
              receiver.args[3] = this.batchSubscriptionsURL[i].url;
            }
            receiver.ref = v.id;
            list.push(receiver);
          }
        });
      } else {
        console.log("cannot find grid");
      }
      return list;
    },
  },
  data() {
    return {
      config: {
        name: "아이디 주문들 ",
        req_endpoint: "/subscriptions",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "신청일",
              start_date: "시작일",
              end_date: "종료일",
              pay_at: "결제일",
              setup_at: "대행일",
            },
          },
          {
            id: "status_filter",
            name: "상태",
            type: "switch",
            filter_type: {
              WAITING_PAYMENT: "결제 대기 중",
              PAYMENT_LATE: "결제 만료",
              CONFIRMING_PAYMENT: "결제 확인 중",
              PENDING: "대행 대기 중",
              ACTIVE: "사용 중",
              ENDED: "만료",
              CANCEL_PENDING: "취소 대기 중",
              CANCELLED: "취소됨",
              RESERVED: "연장",
            },
          },
          {
            id: "paymethod_filter",
            name: "결제 방법",
            type: "switch",
            filter_type: {
              CARD_ONPG: "ON 신용카드",
              CARD_OFFPG: "OFF 신용카드",
              CASH: "현금",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "주문번호/아이디/이름/승인번호",
          },
        ],
        columns: [
          {
            id: "chkbox",
            name: "체크",
            is_check: true,
            excel_print: false,
          },
          {
            id: "id",
            sortable: true,
            name: "#",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "order_id",
            sortable: true,
            name: "주문번호",
            excel_print: (v) => {
              return v.orderId + (v.previous_order ? "[연장]" : "");
            },
          },
          {
            id: "created_at",
            sortable: true,
            name: "신청일",
            excel_print: (v) => {
              return v.createdAt;
            },
          },
          {
            id: "biz",
            sortable: true,
            name: "학원/캠퍼스",
            excel_print: (v) => {
              return v.p_biz.name;
            },
          },
          {
            id: "class",
            sortable: true,
            name: "클래스",
            excel_print: (v) => {
              return v.biz.name;
            },
          },
          {
            id: "username",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanname",
            sortable: true,
            name: "이름",
            excel_print: (v) => {
              return v.hanName;
            },
          },
          {
            id: "product_name",
            sortable: true,
            name: "상품명",
            excel_print: (v) => {
              return v.productName;
            },
          },
          {
            id: "period",
            sortable: true,
            name: "기간",
            excel_print: (v) => {
              return v.period;
            },
          },
          {
            id: "level",
            sortable: true,
            name: "과정",
            excel_print: (v) => {
              return v.level;
            },
          },
          {
            id: "payment_method",
            sortable: true,
            name: "결제방법",
            excel_print: (v) => {
              var a = {
                CASH: "현금",
                CARD_ONPG: "온라인 카드",
                CARD_OFFPG: "오프라인 카드",
              };
              return a[v.paymentMethod];
            },
          },
          {
            id: "price",
            sortable: true,
            name: "금액",
            excel_print: (v) => {
              return v.price;
            },
          },
          {
            id: "end_date",
            sortable: true,
            name: "종료일",
            excel_print: (v) => {
              return v.endDate;
            },
          },
          {
            id: "status",
            sortable: true,
            name: "상태",
            excel_print: (v) => {
              var a = {
                WAITING_PAYMENT: "결제 대기 중",
                PAYMENT_LATE: "결제 만료",
                CONFIRMING_PAYMENT: "결제 확인 중",
                PENDING: "대행 대기 중",
                ACTIVE: "사용 중",
                ENDED: "만료",
                CANCEL_PENDING: "취소 대기 중",
                CANCELLED: "취소됨",
                RESERVED: "연장",
              };
              return a[v.status];
            },
          },
          {
            id: "e",
            name: "비고",
            excel_print: false,
          },
        ],
      },
      subscriptions: [],

      payUrl: "",

      tabActive: "subscription",

      records: [],
      is_extend: false,
      ext_subscriptions: [],

      batchSubscriptionsDetail: [],
      batchSubscriptionsURL: [],
    };
  },
  computed: {},
};
</script>
